import { Component, inject } from "@angular/core";
import { BootstrapService } from "./modules/bootstrap/bootstrap.service";
import { GlobalRouteGuardService } from "./guards/global-tab-route-guard-inject";
import { TabService } from "src/app/services/tab.service";
import { Subscription } from "rxjs";
import { TitleService } from "src/app/services/title.service";
import { PWAService } from "src/app/services/pwa.service";
import { PlatformService } from "src/app/services/platform.service";

interface BeforeInstallPromptEvent extends Event {
  readonly platforms: string[];
  readonly userChoice: Promise<{
    outcome: "accepted" | "dismissed";
    platform: string;
  }>;
  prompt(): Promise<void>;
}

declare global {
  interface WindowEventMap {
    beforeinstallprompt: BeforeInstallPromptEvent;
  }
}

@Component({
  standalone: false,
  selector: "app-root",
  templateUrl: "app.component.html",
  styles: `
    :host {
      display: flex;
      flex: 1;
    }
  `
})
export class AppComponent {
  private readonly tabService = inject(TabService);
  private readonly titleService = inject(TitleService);
  private readonly bootstrapService = inject(BootstrapService);
  private readonly globalRouteGuardService = inject(GlobalRouteGuardService);

  constructor() {
    inject(PWAService).listenEvent();
    inject(PlatformService).init();

    this.globalRouteGuardService.ensureGlobalGuards();

    let prevTabActivatedSubscriptions: Subscription[] = [];

    this.bootstrapService.productTitle$.subscribe((titleValue) => {
      this.titleService.set(titleValue);
    });

    this.tabService.tabActivated$.subscribe((tab) => {
      prevTabActivatedSubscriptions.forEach((subscription) => {
        subscription.unsubscribe();
      });

      if (tab.route?.name$) {
        prevTabActivatedSubscriptions.push(
          tab.route!.name$.subscribe((name) => {
            this.titleService.set(name);
          })
        );
      }
    });
  }
}
